import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  BLACKLIST: {
    LIST_ALL: {
      REFRESH: 'BLACKLIST.LIST_ALL.REFRESH',
      REFRESHING: 'BLACKLIST.LIST_ALL.REFRESHING',
      REFRESHED: 'BLACKLIST.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'BLACKLIST.LIST_ALL.REFRESH_ERROR'
    },
    ADD: {
      SHOW: 'BLACKLIST.ADD.SHOW',
      SUBMIT: 'BLACKLIST.ADD.SUBMIT',
      SUCCESS: 'BLACKLIST.ADD.SUCCESS',
      ERROR: 'BLACKLIST.ADD.ERROR'
    },
    REMOVE: {
      SUBMIT: 'BLACKLIST.REMOVE.SUBMIT',
      SUCCESS: 'BLACKLIST.REMOVE.SUCCESS',
      ERROR: 'BLACKLIST.REMOVE.ERROR'
    }
  }
};

export const ENDPOINTS = {
  BLACKLIST: {
    GET_LIST:
      'https://api.kingrecharges.com/bookmaker/blacklisted?group=lacasae&service={service}',
    ADD:
      'https://api.kingrecharges.com/bookmaker/blacklist/{playerId}?group=lacasae&service={service}&currency={currency}',
    REMOVE:
      'https://api.kingrecharges.com/bookmaker/blacklist/{playerId}?group=lacasae&service={service}&currency={currency}'
  }
};

export const BLACKLIST = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  },
  SERVICES: ['1bpay', '1xpay', 'kingrecharge'],
  CURRENCIES: ['xof', 'xaf']
};
